/**
 * Supply bento — ambient video, ship slideshow and expand (section#supply-bento).
 *
 * Ported verbatim from adensalt.com (live code as of 2026-10-01):
 *   1. js/reduced-motion-video.js — the original placed this inline right after the
 *      <video class="sb-video"> and found it with document.currentScript.previousElementSibling.
 *      The bundle has no currentScript context, so it selects every .sb-video instead; the
 *      body of the function is unchanged.
 *   2. The "Supply bento: ambient video plays only while on screen and the tab is visible;
 *      never with reduced motion" IIFE from js/section-scripts-a.js — unchanged. Since
 *      2026-09-30 it also moves the video's data-src to src when the card nears the viewport.
 *      1 and 2 keep the original's "use strict" wrapper (section-scripts-a.js is one IIFE).
 *   3. The "Supply bento card A: crossfading ship slideshow" and
 *      "Supply bento card A: expand / collapse (corner button)" IIFEs from
 *      js/section-scripts-b.js — unchanged, at top level as in the original (no strict mode).
 *      They key off .sb-ship / #sbShipCard / .sb-set-d / .sb-set-m / .sb-slide / .sb-bars /
 *      .sb-toggle / .sb-arrow / .sb-live / .sb-expand emitted by
 *      parts/sections/supply_bento.php. Since 2026-10-01 the slideshow carries two slide
 *      lists (landscape .sb-set-d, portrait .sb-set-m) and swaps between them on
 *      matchMedia('(max-width:1020px)'): it rebuilds the .sb-bars buttons for the active
 *      list, re-points their aria-controls (and the toggle's and arrows') at that list's id
 *      and restarts at photo 1. The server-rendered bars describe the desktop list, so the
 *      page is correct before the script runs. The expand IIFE collapses the card when the
 *      same breakpoint is crossed into the stacked layout.
 *
 * Runs from the concatenated footer bundle, after the DOM is parsed (like the original block).
 */
(function(){
  "use strict";
  /* ---------- Inline snippet after the bento <video>: no autoplay with reduced motion ---------- */
  Array.prototype.slice.call(document.querySelectorAll('.sb-video')).forEach(function(el){
    (function(v){ if(v && window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches){ v.autoplay = false; v.removeAttribute('autoplay'); try{ v.pause(); }catch(e){} } })(el);
  });
  /* ---------- Supply bento: ambient video plays only while on screen and the tab is visible; never with reduced motion ---------- */
  (function(){
    var vids = Array.prototype.slice.call(document.querySelectorAll('video.sb-video'));
    if(!vids.length) return;
    var rm = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
    function still(){ return !!(rm && rm.matches); }
    vids.forEach(function(v){
      v.muted = true; v.controls = false;
      var onScreen = false;
      function sync(){
        if(still() || !onScreen || document.hidden){ if(!v.paused) v.pause(); return; }
        var ds = v.getAttribute('data-src');
        if(ds){ v.removeAttribute('data-src'); v.preload = 'auto'; v.src = ds; }
        if(v.paused){ var pr = v.play(); if(pr && pr.catch) pr.catch(function(){}); }
      }
      if(still()){ v.autoplay = false; v.removeAttribute('autoplay'); v.pause(); }
      if('IntersectionObserver' in window){
        new IntersectionObserver(function(entries){ onScreen = entries[0].isIntersecting; sync(); }, {rootMargin:'200px 0px'}).observe(v);
      } else { onScreen = true; sync(); }
      document.addEventListener('visibilitychange', sync);
      if(rm){ if(rm.addEventListener) rm.addEventListener('change', sync); else if(rm.addListener) rm.addListener(sync); }
    });
  })();
})();
/* ---------- Supply bento card A: crossfading ship slideshow ----------
   Two slide lists: the landscape set (1021px and up) and John's 4:5 portrait set (1020px and under, where the bento
   stacks). Only the active list ever gets its src: its first photo right away, the rest once the card nears the viewport.
   Crossing the breakpoint swaps lists, rebuilds the bars and restarts at photo 1.
   Advances every 5s. Pauses on hover, on keyboard focus inside the card, while offscreen and while the tab is hidden;
   the toggle pauses it for good. Reduced motion: no autoplay (photo 1 stays), the bars, arrows and toggle still work. */
(function(){
  var card = document.querySelector('.sb-ship');
  if(!card) return;
  var lists = {d: card.querySelector('.sb-set-d'), m: card.querySelector('.sb-set-m')};
  var barsWrap = card.querySelector('.sb-bars');
  var tog = card.querySelector('.sb-toggle');
  var arrows = [].slice.call(card.querySelectorAll('.sb-arrow'));
  var live = card.querySelector('.sb-live');
  if(!lists.d || !barsWrap) return;
  var mq = window.matchMedia ? window.matchMedia('(max-width:1020px)') : null;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var key = null, slides = [], bars = [], n = 0, i = 0, timer = null;
  var userPaused = !!reduce, hover = false, focusIn = false, inView = false, loaded = {};
  function setSrc(im){ if(im && im.hasAttribute('data-src')){ im.src = im.getAttribute('data-src'); im.removeAttribute('data-src'); } }
  function load(){
    if(loaded[key]) return; loaded[key] = true;
    slides.forEach(function(s){ setSrc(s.querySelector('img[data-src]')); });
  }
  function go(k, announce){
    i = (k % n + n) % n;
    slides.forEach(function(s, j){
      s.classList.toggle('is-active', j === i);
      if(j === i) s.removeAttribute('aria-hidden'); else s.setAttribute('aria-hidden', 'true');
    });
    bars.forEach(function(b, j){ if(j === i) b.setAttribute('aria-current', 'true'); else b.removeAttribute('aria-current'); });
    if(announce && live) live.textContent = 'Photo ' + (i + 1) + ' of ' + n;
  }
  function running(){ return n > 1 && !userPaused && !hover && !focusIn && inView && !document.hidden; }
  function sync(){
    clearTimeout(timer); timer = null;
    if(running()) timer = setTimeout(function(){ go(i + 1, false); sync(); }, 5000);
  }
  function setPaused(p){
    userPaused = p;
    if(tog){ tog.classList.toggle('is-paused', p); tog.setAttribute('aria-label', p ? 'Play slideshow' : 'Pause slideshow'); }
    sync();
  }
  function use(k){
    if(!lists[k]) k = 'd';
    if(k === key) return;
    key = k;
    var list = lists[k];
    slides = [].slice.call(list.querySelectorAll('.sb-slide'));
    n = slides.length;
    [tog].concat(arrows).forEach(function(el){ if(el) el.setAttribute('aria-controls', list.id); });
    barsWrap.innerHTML = '';
    bars = slides.map(function(_, j){
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'sb-bar';
      b.setAttribute('aria-controls', list.id);
      b.setAttribute('aria-label', 'Show photo ' + (j + 1) + ' of ' + n);
      b.addEventListener('click', function(){ load(); go(j, true); sync(); });
      barsWrap.appendChild(b);
      return b;
    });
    setSrc(slides[0] && slides[0].querySelector('img'));
    go(0, false);
    if(inView) load();
    sync();
  }
  /* prev/next loop at the ends and restart the 5s timer; they don't pause the show by themselves */
  arrows.forEach(function(a){
    a.addEventListener('click', function(){ load(); go(i + Number(a.getAttribute('data-dir')), true); sync(); });
  });
  card.addEventListener('keydown', function(e){
    if(e.key !== 'ArrowLeft' && e.key !== 'ArrowRight') return;
    if(!e.target.closest || !e.target.closest('.sb-ctrl, .sb-media')) return;
    e.preventDefault(); load(); go(i + (e.key === 'ArrowRight' ? 1 : -1), true); sync();
  });
  if(tog) tog.addEventListener('click', function(){ load(); setPaused(!userPaused); });
  card.addEventListener('pointerenter', function(e){ if(e.pointerType === 'mouse'){ hover = true; sync(); } });
  card.addEventListener('pointerleave', function(e){ if(e.pointerType === 'mouse'){ hover = false; sync(); } });
  /* keyboard focus pauses the show; a mouse click on a control (expand, arrows) doesn't */
  card.addEventListener('focusin', function(e){
    var kb = true; try{ kb = e.target.matches(':focus-visible'); }catch(err){}
    if(kb){ focusIn = true; sync(); }
  });
  card.addEventListener('focusout', function(e){ if(!card.contains(e.relatedTarget)){ focusIn = false; sync(); } });
  document.addEventListener('visibilitychange', sync);
  use(mq && mq.matches ? 'm' : 'd');
  if(mq){
    var onChange = function(){ use(mq.matches ? 'm' : 'd'); };
    if(mq.addEventListener) mq.addEventListener('change', onChange); else if(mq.addListener) mq.addListener(onChange);
  }
  if('IntersectionObserver' in window){
    new IntersectionObserver(function(entries){
      entries.forEach(function(en){ inView = en.isIntersecting; if(inView) load(); sync(); });
    }, {threshold:0.25}).observe(card);
  } else { inView = true; load(); }
  setPaused(userPaused);
})();
/* ---------- Supply bento card A: expand / collapse (corner button) ----------
   Toggles .is-open on the card and .is-ship-open on the grid. Animated with the View Transitions API where it exists
   (400ms morph), with no animation otherwise and with reduced motion. After opening, a card whose top is above the viewport
   scrolls into view. Escape collapses while focus is inside the card. */
(function(){
  var card = document.getElementById('sbShipCard');
  var btn = card && card.querySelector('.sb-expand');
  var grid = card && card.closest('.sb-grid');
  if(!btn || !grid) return;
  var rmq = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;
  function reduced(){ return !!(rmq && rmq.matches); }
  function apply(open){
    card.classList.toggle('is-open', open);
    grid.classList.toggle('is-ship-open', open);
    btn.setAttribute('aria-expanded', open ? 'true' : 'false');
    btn.setAttribute('aria-label', open ? 'Collapse photos' : 'Expand photos');
  }
  function reveal(){
    var hh = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--header-h')) || 73;
    if(card.getBoundingClientRect().top < hh) card.scrollIntoView({behavior: reduced() ? 'auto' : 'smooth', block: 'start'});
  }
  function set(open){
    if(open === card.classList.contains('is-open')) return;
    if(!reduced() && document.startViewTransition){
      grid.classList.add('is-vt');
      var vt = document.startViewTransition(function(){ apply(open); });
      vt.finished.then(function(){ grid.classList.remove('is-vt'); if(open) reveal(); }, function(){ grid.classList.remove('is-vt'); });
    } else {
      apply(open);
      if(open) reveal();
    }
  }
  btn.addEventListener('click', function(){ set(!card.classList.contains('is-open')); });
  /* the stacked layout (1020px and under) has no expanded state: crossing into it collapses the card */
  var smq = window.matchMedia ? window.matchMedia('(max-width:1020px)') : null;
  if(smq){
    var onSm = function(){ if(smq.matches) apply(false); };
    if(smq.addEventListener) smq.addEventListener('change', onSm); else if(smq.addListener) smq.addListener(onSm);
  }
  card.addEventListener('keydown', function(e){
    if(e.key === 'Escape' && card.classList.contains('is-open')){ e.preventDefault(); set(false); btn.focus(); }
  });
})();
